module.exports = "img/prac-info-slide-6.a80399.jpeg";